/**
 * Standalone entry point for Global OneDoC Listener.
 *
 * This file is loaded as a footerInclude on every page (via AEM config).
 * It auto-initializes the postMessage listener at script load time,
 * capturing DoC MS callbacks for both guest and logged-in users.
 */
import { initDocmsListener } from './lc/docms-global-listener.js';  
import { logIfDebugEnabled } from './lc/dependencies/utils.es6';  
  
logIfDebugEnabled('[OneDoC] Standalone listener script loaded — initializing on this page');  
initDocmsListener();
